import Cookies from 'js-cookie'

export const tracking_data = () => {
    const hubspot_cookie = Cookies.get('hubspotutk');
    return {
        id: hubspot_cookie ? hubspot_cookie : '',
        // remove the query string and shebang from the URL
        page_uri: window.location.href.split('?')[0].split('#')[0],
        page_name: document.title || ''
    }
}